import React, { useEffect, useMemo } from 'react';
import SubpageTopBar from './SubpageTopBar';
import AppLegalDocumentLayout from '../components/AppLegalDocumentLayout';
import { getAppConfig, isKnownAppSlug } from '../config/apps';
import { getTermsPageContent } from '../content/terms';
import NotFoundPage from './NotFoundPage';

function AppTermsOfUsePage({ match }) {
  const { appSlug } = match.params;
  const validSlug = isKnownAppSlug(appSlug);
  const app = validSlug ? getAppConfig(appSlug) : null;

  const termsContent = useMemo(
    () => (validSlug ? getTermsPageContent(appSlug) : null),
    [validSlug, appSlug]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [appSlug]);

  useEffect(() => {
    if (!validSlug || !app || !termsContent) {
      return undefined;
    }
    document.title = `Terms of Use – ${app.contact.brandName}`;
    return () => {
      document.title = 'East IT';
    };
  }, [validSlug, app, termsContent]);

  if (!validSlug || !app || !termsContent) {
    return <NotFoundPage />;
  }

  return (
    <div className="App">
      <SubpageTopBar />
      <AppLegalDocumentLayout
        contact={app.contact}
        docTitle={termsContent.pageTitle}
        subtitle={termsContent.subtitle}
        updatedBadge={termsContent.updatedBadge}
        tocTitle={termsContent.tocTitle}
        tocItems={termsContent.tocItems}
        sections={termsContent.sections}
      />
    </div>
  );
}

export default AppTermsOfUsePage;
